<!-- src/app/components/cookie-banner/cookie-banner.component.html -->
<div *ngIf="visible" class="cookie-banner" role="region" aria-label="Cookie notice">
  <p>
    This site uses Google Analytics and Meta Pixel to understand visitor traffic.
    No personal data is sold. &nbsp;
    <a routerLink="/privacy">Privacy Policy</a>
  </p>
  <button (click)="dismiss()" aria-label="Dismiss cookie notice">Got it</button>
</div>
